export const required = [{ required: true, whitespace: true }];
export const requiredNoWs = [{ required: true }];

export const requiredRules = {
  rules: requiredNoWs
};
